import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Switch, useParams } from 'react-router-dom';
import { compile } from 'path-to-regexp';
import { SecuritizePage } from '@securitize/ui-components';
import SecureRoute from '../../../../../containers/SecureRoute/SecureRoute';
import { getOpportunityRoutes } from './routes';

const InvestmentHandler = (props) => {
  const { user, wizardData } = props;
  const params = useParams();
  const { accreditationFirst, isAccredited, verificationStatus } = user || {};
  const opportunityRoutes = getOpportunityRoutes(isAccredited, accreditationFirst,
    wizardData.allowSkipAccreditation);

  const routes = verificationStatus === 'verified'
    ? opportunityRoutes
    : [opportunityRoutes[0]];

  const getRoute = (route) => (route ? compile(route.path, { encode: encodeURIComponent })(params) : undefined);
  const getPage = (type, index) => (type === 'previous' ? routes[index - 1] : routes[index + 1]);

  return (
    <Switch>
      {
        routes.map((route, index) => (
          <SecureRoute
            key={route.path}
            path={route.path}
            exact={route.exact}
            name={route.name}
            nextPage={getRoute(getPage('next', index))}
            previousPage={getRoute(getPage('previous', index))}
            currentPage={getRoute(routes[index])}
            opportunityId={params.id}
            component={(props) => (
                <route.component {...props} pageNumber={index + 1} routesLength={routes.length} /> // eslint-disable-line
            )}
          />
        ))
      }
      <SecuritizePage isLoading />
    </Switch>
  );
};

InvestmentHandler.defaultProps = { user: {}, wizardData: {} };
InvestmentHandler.propTypes = {
  user: PropTypes.objectOf(PropTypes.any),
  wizardData: PropTypes.shape({ allowSkipAccreditation: PropTypes.bool }),
};
const mapStateToProps = ({ investment: { opportunityWizard }, auth: { user } }) => ({ user, wizardData: opportunityWizard.data });
export default connect(mapStateToProps, {})(InvestmentHandler);
